import React, { Component } from "react";

import clsx from 'clsx';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as calledsActions from '../../redux/actions/calleds';
import * as userSessionActions from '../../redux/actions/user-session';

import { FormattedMessage, injectIntl } from 'react-intl';

import Api from "../../services/api";
import * as CalledService from '../../services/called.service';
import * as StatusService from "../../services/status.service"
import * as DashboardService from "../../services/dashboard.service";
import { useStatisticsDashboard } from "../../services/statisticsdashboard.service";
import { getAllSelectionModel } from '../../services/techinicalteam.service'

import { evaluateSession } from '../../utils/sessionUtils'
import { PapiroConsole } from "../../utils/papiroConsole";
import { formatedStatisticsDashboardData } from "../../utils/statisticsDashboard";
import { exportOperationsDashboardPdf } from '../../utils/exportOperationsDashboardPdf';

import moment from 'moment';

import { withStyles } from "@mui/styles";
import Typography from '@mui/material/Typography';
import { Styles } from "../../styles/material-styles";
import { CircularProgress, Grid } from '@mui/material';
import { IconButton } from '@mui/material';
import { Button } from '@mui/material';

import HeaderMenu from "../../components/header-menu";
import CustomizedSnackbars from "../../components/material-snackbars"
import Footer from '../../components/footer';
import SimpleDatePicker from '../../components/date-pickers/inline-no-today';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import SimpleAutoCompleteMultiple from "../../components/auto-complete/autocomplete-multiple-create";
import ChartModal from "../../components/modal-chart-expanded";
import DialogSystemAlert from "src/components/dialog-system-alert";
import MetricCard from "./components/metricCard"
import DonutCard from "./components/donutCard"
import PerformanceCard from "./components/performanceCard"
import SlaCard from "./components/slaCard"
import TicketsByHourCard from "./components/ticketsByHourCard"
import DashboardCardsSkeleton from "./components/dashboardCardsSkeleton";

import { RefreshCw } from 'lucide-react';
import { FileDownload } from '@mui/icons-material';

const getInitialDashboardFilters = () => {
  const currentDate = moment().format('YYYY/MM/DD HH:mm:ss');

  return {
    dateStart: currentDate,
    dateEnd: currentDate,
    organization: 0,
    selectedStatus: [],
    technicalTeam: 0,
  };
};

class Dashboard extends Component {

  constructor(props) {
    super(props);

    const { userSession } = this.props;

    // VALIDAÇÃO NA SESSÃO DO USUÁRIO
    evaluateSession(userSession)

    this.isClient = true;
    this.globalAdm = false;
    this.AdmOrganization = false;
    this.onlyAdmOrganization = false;

    userSession.user.userrole.map((item, key) => {
      if (item.role.roletype != 3) {
        this.isClient = false;
      }
      if (item.role.roletype == 0) {
        this.globalAdm = true;
      }
      if (item.role.roletype == 1) {
        this.AdmOrganization = true;
      }
      if (item.role.roletype == 4) {
        this.isCoordenator = true;
      }
    });
    if (this.AdmOrganization == true && this.globalAdm == false) {
      this.onlyAdmOrganization = true;
    }

    // SE NÃO TIVER 'userrole' LOGOUT
    if (userSession.user.userrole == null) {
      Api.logoff();
    }

    const initialStatisticsData = formatedStatisticsDashboardData({
      statisticsData: null,
      intl: this.props.intl,
    });

    this.state = {
      ...getInitialDashboardFilters(),

      loading: true,
      exportingPdf: false,

      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",

      modalopen: false,

      organizationsList: [],
      statusList: [],
      technicalTeamList: [],

      dialogSystemAlert: false,
      dialogSystemAlertMessage: '',
      dialogSystemAlertName: '',

      ...initialStatisticsData,
    };

    this.getStatisticsDashboardData = this.getStatisticsDashboardData.bind(this);
    this.getStatisticsFilters = this.getStatisticsFilters.bind(this);
    this.getOrganizations = this.getOrganizations.bind(this);
    this.getTechnicalTeamList = this.getTechnicalTeamList.bind(this);
    this.getStatus = this.getStatus.bind(this);

    this.search = this.search.bind(this);
    this.getExcelNew = this.getExcelNew.bind(this);
    this.getPdf = this.getPdf.bind(this);

    this.changeValues = this.changeValues.bind(this);
    this.clear = this.clear.bind(this);

    this.handleOpenDialogSystemAlert = this.handleOpenDialogSystemAlert.bind(this);
    this.handleCloseDialogSystemAlert = this.handleCloseDialogSystemAlert.bind(this);
    this.handleWarningWithDateComparison = this.handleWarningWithDateComparison.bind(this);

    this.redirectToCalledListWithFilter = this.redirectToCalledListWithFilter.bind(this);

    this.closeNotification = this.closeNotification.bind(this);
  }

  async componentDidMount() {
    try {
      this.setState({ loading: true })

      const promises = [
        this.getStatisticsDashboardData(),
      ];

      if (this.AdmOrganization || this.globalAdm || this.isCoordenator) {
        promises.push(this.getOrganizations());
      }

      if (!this.isClient) {
        promises.push(this.getTechnicalTeamList());
        promises.push(this.getStatus());
      }

      await Promise.all(promises);

      if (this.props.userSession && this.props.userSession.user && this.props.userSession.user.startpage && this.props.userSession.user.startpage == "dashboard" && this.props.userSession.user.alert && this.props.userSession.user.alertalreadydisplayed == false) {
        this.handleOpenDialogSystemAlert(this.props.userSession.user.alert)
      }

    } catch (error) {
      PapiroConsole.log("ERROR - Dashboard - index2 - componentDidMount: ", error)
    } finally {
      this.setState({ loading: false })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "reload") {
      this.componentDidMount();
    }
  }

  getStatisticsDashboardData = async () => {
    const statisticsData = await this.props.statisticsDashboard
      .fetchStatisticsDashboardData(this.getStatisticsFilters());

    if (!statisticsData) {
      return null;
    }

    const formattedStatisticsData = formatedStatisticsDashboardData({
      statisticsData,
      intl: this.props.intl,
    });

    this.setState(formattedStatisticsData);
    return formattedStatisticsData;
  };

  getStatisticsFilters = () => ({
    dateStart: moment(this.state.dateStart).format('YYYY-MM-DD'),
    dateEnd: moment(this.state.dateEnd).format('YYYY-MM-DD'),
    organizationId: this.state.organization ? this.state.organization.id : 0,
    technicalTeamId: this.state.technicalTeam ? this.state.technicalTeam.id : 0,
    statusIds: this.state.selectedStatus.map(status => status.id).join(','),
  });

  async getOrganizations() {
    const { userSession } = this.props

    let orgData = []
    if (userSession && userSession.user && userSession.user.userorganizations && userSession.user.userorganizations.length > 0) {
      orgData = userSession.user.userorganizations
    } else {
      const result = await CalledService.getOrganizations();
      if (result.success) {
        orgData = result.data
      } else {
        const intl = this.props.intl;
        this.setState({
          openNotification: true, notificationVariant: "error",
          notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
        });
        Api.kickoff(result);
      }
    }

    if (orgData != null) {
      this.setState({ organizationsList: orgData })
    }
  };

  async getTechnicalTeamList() {
    const result = await getAllSelectionModel();

    if (result.success) {
      this.setState({ technicalTeamList: result.data })
    } else {
      const intl = this.props.intl;
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage: result.response && result.response.data && result.response.data.errors ? result.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
      });
      Api.kickoff(result);
    }
  }

  async getStatus() {
    const intl = this.props.intl;

    await StatusService.getAllSelectionModel()
      .then(result => {
        if (result.success) {
          this.setState({ statusList: result.data })
        } else {
          this.setState({
            openNotification: true, notificationVariant: 'error',
            notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
          });
          Api.kickoff(result);
        }
      })
  }

  async search() {
    let dateStart = moment(this.state.dateStart).format('YYYY-MM-DD');
    let dateEnd = moment(this.state.dateEnd).format('YYYY-MM-DD');

    if (dateStart > dateEnd) {
      this.handleWarningWithDateComparison();
    } else {
      await Promise.all([
        this.getStatisticsDashboardData(),
      ])
    }
  }

  async getExcelNew() {
    this.setState({ loading: true })

    let startDate = moment(this.state.dateStart).format('YYYY-MM-DD');
    let endDate = moment(this.state.dateEnd).format('YYYY-MM-DD');

    if (startDate > endDate) {
      this.handleWarningWithDateComparison();
      return;
    }

    let data = {
      totalCalleds: null,
      comparation: null,
      progress: null,
      slaMonth: null,
      calledStatus: null,
      calledDataPerMonth: null,
      dateStart: startDate,
      dateEnd: endDate
    }

    var result = await DashboardService.exportDashboardOperation(data);

    if (result && result.success) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'success',
        notificationMessage: this.props.intl.formatMessage({
          id: 'dashboard.new.operation.export.email.success',
        }),
      })

    } else {
      const intl = this.props.intl

      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: result && result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
      })
      Api.kickoff(result)
    }
    this.setState({ loading: false })
  }

  async changeValues(stateName, value, text = '') {
    if (stateName === "organization") {
      this.setState({ organization: value });
    } else if (stateName === "dateEnd") {
      if (value < this.state.dateStart) {
        this.handleWarningWithDateComparison();
      }
    }

    this.setState({ [stateName]: value });
  };

  async clear() {
    await new Promise(resolve => {
      this.setState(getInitialDashboardFilters(), resolve);
    });

    await this.search();
  }

  async getPdf() {
    const statisticsDashboard = this.props.statisticsDashboard;
    const statisticsLoading = statisticsDashboard
      && statisticsDashboard.loading;

    if (
      this.state.loading
      || statisticsLoading
      || this.state.exportingPdf
    ) {
      return;
    }

    this.setState({ exportingPdf: true });

    try {
      await exportOperationsDashboardPdf({
        elementId: 'operations-dashboard-content',
        fileName: `${this.props.intl.formatMessage({
          id: 'dashboards.operation.file',
        })}-${moment().format('YYYY-MM-DD-HHmm')}.pdf`,
      });
    } catch (err) {
      PapiroConsole.log('ERROR - Dashboard - getPdf: ', err);

      this.setState({
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: (err && err.message)
          || this.props.intl.formatMessage({ id: 'process.error' }),
      });
    } finally {
      this.setState({ exportingPdf: false });
    }
  }

  handleOpenDialogSystemAlert(alert) {
    this.setState({ dialogSystemAlertMessage: alert.message, dialogSystemAlertName: alert.title, dialogSystemAlert: true });

    setTimeout(this.handleCloseDialogSystemAlert, alert.time * 1000);
  }

  handleCloseDialogSystemAlert() {
    this.setState({ dialogSystemAlert: false });
    this.props.updateAlertAlreadyDisplayed(true)
  }

  handleWarningWithDateComparison() {
    this.setState({
      openNotification: true,
      notificationVariant: "error",
      notificationMessage: this.props.intl.formatMessage({
        id: 'dashboard.new.operation.date.invalidRange',
      }),
      loading: false
    });
  }

  redirectToCalledListWithFilter(search) {
    const statisticsLoading = this.props.statisticsDashboard?.loading;

    if (
      this.state.loading
      || statisticsLoading
      || this.state.exportingPdf
    ) {
      return;
    }

    this.setState({ loading: true })

    this.props.history.push({
      pathname: `/${this.props.match.params.lang}/calleds`,
      state: {
        field: 'newdashboardmetriccards',
        search: search,
        type: 1,
        origin: 'dashboardcards'
      }
    })

    this.setState({ loading: false })
  }

  closeNotification = _ => {
    this.setState({ openNotification: false });
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const intl = this.props.intl;
    const {
      loading: statisticsLoading,
      notification: statisticsNotification,
      clearNotification: clearStatisticsNotification,
    } = this.props.statisticsDashboard;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`
    }

    const {
      metricCards,
      statusData,
      totalTickets,
      performanceData,
      organizationData,
      totalOrganizations,
      slaItems,
      ticketsByHour
    } = this.state;

    const allLoading = this.state.loading || statisticsLoading

    return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >

          <div className={classes.drawerHeader} style={{ minWidth: '300px' }} />

          <Grid
            id="operations-dashboard-content"
            container
            spacing={2}
            sx={{ bgcolor: "transparent", pr: "2rem", pb: "4rem" }}
          >
            <Grid container item xs={12} spacing={2}>
              <Grid
                item
                xs={10.8}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  gap: 2,
                }}
              >
                <Typography variant="h3" fontWeight="bold">
                  <FormattedMessage id="operation.dashboards.title" />
                </Typography>

                <IconButton
                  aria-label={intl.formatMessage({
                    id: 'dashboard.new.operation.refresh',
                  })}
                  color="primary"
                  data-html2canvas-ignore="true"
                  onClick={this.getStatisticsDashboardData}
                  disabled={allLoading}
                >
                  <RefreshCw
                    size={20}
                    absoluteStrokeWidth
                    color="currentColor"
                  />
                </IconButton>
              </Grid>

              <Grid item xs={1.2} data-html2canvas-ignore="true">
                <Button
                  id="export"
                  variant='outlined'
                  color='secondary'
                  size='large'
                  onClick={this.getPdf}
                  fullWidth
                  startIcon={this.state.exportingPdf
                    ? <CircularProgress color="inherit" size={18} />
                    : <FileDownload />}
                  disabled={allLoading || this.state.exportingPdf}
                >
                  {<FormattedMessage id="export" />}
                </Button>
              </Grid>
            </Grid>

            <Grid container item xs={12} spacing={1} alignItems={"center"}>
              <Grid item xs={1.5}>
                <SimpleDatePicker label={intl.formatMessage({ id: "start.date" })} name='dateStart' stateName='dateStart' changeDate={this.changeValues} currentDate={this.state.dateStart} required />
              </Grid>

              <Grid item xs={1.5}>
                <SimpleDatePicker label={intl.formatMessage({ id: "end.date" })} name='dateEnd' stateName='dateEnd' changeDate={this.changeValues} currentDate={this.state.dateEnd} required />
              </Grid>

              {(this.AdmOrganization || this.globalAdm || this.isCoordenator) &&
                <Grid item xs={2}>
                  <SimpleAutoComplete
                    label={intl.formatMessage({ id: "productivity.dashboard.organizations" })}
                    options={this.state.organizationsList}
                    stateName="organization"
                    changeSelect={this.changeValues}
                    selected={this.state.organization}
                  />
                </Grid>
              }

              {(!this.isClient) &&
                <Grid item xs={2}>
                  <SimpleAutoComplete
                    label={intl.formatMessage({ id: "productivity.dashboard.techinical.teams" })}
                    options={this.state.technicalTeamList}
                    stateName="technicalTeam"
                    changeSelect={this.changeValues}
                    selected={this.state.technicalTeam}
                  />
                </Grid>
              }

              {(!this.isClient) &&
                <Grid item xs={2}>
                  <SimpleAutoCompleteMultiple
                    label={intl.formatMessage({ id: "menu.statuses" })}
                    options={this.state.statusList}
                    stateName='selectedStatus'
                    changeSelect={this.changeValues}
                    selected={this.state.selectedStatus}
                  />
                </Grid>
              }

              <Grid item xs={2} sm={2} md={2} lg={0.8} />

              <Grid item xs={1} data-html2canvas-ignore="true">
                <Button
                  variant='contained'
                  color='secondary'
                  size='large'
                  onClick={this.search}
                  fullWidth
                  disabled={allLoading}
                >
                  {<FormattedMessage id="search" />}
                </Button>
              </Grid>

              <Grid item xs={1.2} data-html2canvas-ignore="true">
                <Button
                  variant='outlined'
                  color='secondary'
                  size='large'
                  onClick={this.clear}
                  fullWidth
                  disabled={allLoading}
                >
                  {<FormattedMessage id="emailsettings.clear" />}
                </Button>
              </Grid>
            </Grid>

            <DashboardCardsSkeleton loading={allLoading}>
              <Grid container item xs={12} spacing={2}>
                {metricCards.map((metric) => (
                  <Grid key={metric.id} item xs={2}>
                    <MetricCard
                      {...metric}
                      onClick={() => {
                        this.redirectToCalledListWithFilter(intl.formatMessage({ id: metric.keyRedirect }))
                      }}
                    />
                  </Grid>
                ))}
              </Grid>

              <Grid container item xs={12} spacing={2}>
                <Grid item xs={4}>
                  <DonutCard
                    title={intl.formatMessage({
                      id: 'dashboard.new.operation.ticketsByStatus',
                    })}
                    data={statusData}
                    total={totalTickets}
                  />
                </Grid>

                <Grid item xs={4}>
                  <PerformanceCard data={performanceData} />
                </Grid>

                <Grid item xs={4}>
                  <DonutCard
                    title={intl.formatMessage({
                      id: 'dashboard.new.operation.ticketsByOrganization',
                    })}
                    data={organizationData}
                    total={totalOrganizations}
                    centerValue={false}
                  />
                </Grid>
              </Grid>

              <Grid container item xs={12} spacing={2}>
                <Grid item xs={6}>
                  <SlaCard data={slaItems} />
                </Grid>

                <Grid item xs={6}>
                  <TicketsByHourCard data={ticketsByHour} />
                </Grid>
              </Grid>
            </DashboardCardsSkeleton>
          </Grid>

          <CustomizedSnackbars
            variant={statisticsNotification?.variant || this.state.notificationVariant}
            message={statisticsNotification?.message || this.state.notificationMessage}
            isOpen={Boolean(statisticsNotification) || this.state.openNotification}
            toClose={clearStatisticsNotification || this.closeNotification} />

          <DialogSystemAlert
            open={this.state.dialogSystemAlert}
            handleCloseDialogSystemAlert={this.handleCloseDialogSystemAlert}
            message={this.state.dialogSystemAlertMessage}
            title={this.state.dialogSystemAlertName}
          />

        </main>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  chatHubConnection: state.chatHubConnection,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(Object.assign({}, calledsActions, userSessionActions), dispatch);


const ConnectedDashboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(Styles)(Dashboard));

function DashboardWithStatistics(props) {
  const statisticsDashboard = useStatisticsDashboard({
    filters: {},
    intl: props.intl,
  });

  return <ConnectedDashboard {...props} statisticsDashboard={statisticsDashboard} />;
}

export default injectIntl(DashboardWithStatistics);
